import React, { useState, useEffect, useRef } from 'react';
import { Typography, QRCode, Button } from 'antd';
import http from '../../utils/request';
import './QRCodeLogin.css';
import errPng from '../../assets/images/err.png';
import okPng from '../../assets/images/ok.png';
import { useLanguage } from '../../context/LanguageContext';

const { Title, Text } = Typography;

const QRCodeLogin = ({ onLoginSuccess,onFeishuLoginSuccess }) => {
  const { language } = useLanguage();
  const [qrCode, setQrCode] = useState('');
  const [loginStatus, setLoginStatus] = useState(1); // 1: waiting, 2: scanned, 0: expired
  const [loginToken, setLoginToken] = useState('');
  const [qrType, setQrType] = useState('');
  const [feishuTenant, setFeishuTenant] = useState('trip'); // 飞书租户类型：trip（主租户）或 partner（伙伴租户）
  const timerRef = useRef(null);

  const content = {
    CN: {
      scanToLogin: "扫码登录",
      scanSuccess: "扫描成功",
      confirmOnPhone: "请在手机上确认登录",
      qrExpired: "二维码已过期",
      refresh: "刷新",
      scanDescription: "请使用公司TripPal扫码登录",
      fesishuScanDescription: "请使用飞书扫码登录",
      switchToPartnerTenant: "切换到伙伴租户扫码",
      switchToPrimaryTenant: "切换到主租户扫码",
    },
    EN: {
      scanToLogin: "Scan Code",
      scanSuccess: "Scan Successful",
      confirmOnPhone: "Please confirm login on your phone",
      qrExpired: "QR code has expired",
      refresh: "Refresh",
      scanDescription: "Please use company TripPal to scan the code for login",
      fesishuScanDescription: "Please use Lark App to scan the QR code",
      switchToPartnerTenant: "Switch to partner tenant QR code scanning",
      switchToPrimaryTenant: "Switch to primary tenant QR code scanning",
    },
  };

  const t = content[language];

  const getQRCode = () => {
    http.post('/api/qrcode/login', {
      type: 'LOGIN_01',
      request_body: {
        APP_ID: '10e65426aa0d45c482e7bca83d9315ca'
      }
    }).then(res => {
      if (res?.data?.result === 'success') {
        setQrCode(res.data.data.QR_CODE);
        setLoginToken(res.data.data.Login_Token);
        setLoginStatus(1);
        startPolling(res.data.data.Login_Token);
      }
    });
  };

  const checkStatus = (token) => {
    http.post('/api/qrcode/login', {
      type: 'LOGIN_02',
      request_body: {
        Login_Token: token
      }
    }).then(res => {
      if (res?.data?.result === 'success') {
        const status = res.data.data.Login_Status - 0;
        setLoginStatus(status);
        if (status === 3) { // authorized
          stopPolling();
          onLoginSuccess({...res.data.data,Login_Token:token});
        }
        if (status === 0) { // expired
          stopPolling();
        }
      } else {
        setLoginStatus(0);
        stopPolling();
      }
    });
  };

  const startPolling = (token) => {
    stopPolling();
    timerRef.current = setInterval(() => {
      checkStatus(token);
    }, 1000);
  };

  const stopPolling = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
  };
  useEffect(() => {
    if(qrType === 'tripPal') {
      getQRCode();
    }
    return () => {
      stopPolling();
    };
  }, [qrType]);
  useEffect(() => {
    http.get('/api/qr/type').then(res => {
      if(res?.data?.code === 0) {
        setQrType(res.data.result || '');
      }
    });
    const savedTenant = localStorage.getItem('feishuTenant');
    if (savedTenant && (savedTenant === 'trip' || savedTenant === 'partner')) {
      setFeishuTenant(savedTenant);
    }
  }, []);

  const handleRefresh = () => {
    getQRCode();
  };
  // 切换飞书租户类型
  const handleFeishuTenantSwitch = () => {
    const newTenant = feishuTenant === 'trip' ? 'partner' : 'trip';
    setFeishuTenant(newTenant);
    // 保存用户偏好到localStorage
    localStorage.setItem('feishuTenant', newTenant);
  };

  window.feishuQrSuccess = () => {
    onFeishuLoginSuccess();
  }
  return (
    <div className="qr-section">
      {qrType === 'tripPal' && 
      <div className="qr-content">
        <Title level={2} className="qr-title">{t.scanToLogin}</Title>
        <div className="qr-code">
          {loginStatus === 1 && (
            <QRCode
              value={qrCode}
              size={144}
              bordered={false}
            />
          )}
          {loginStatus === 2 && (
            <div className="qr-status">
              <img src={okPng} alt="Scanned" />
              <Text>{t.scanSuccess}</Text>
              <Text>{t.confirmOnPhone}</Text>
            </div>
          )}
          {loginStatus === 0 && (
            <div className="qr-status expired">
              <img src={errPng} alt="Expired" />
              <Text>{t.qrExpired}</Text>
              <a onClick={handleRefresh}>{t.refresh}</a>
            </div>
          )}
        </div>
        <div>
          <Text className="qr-description">
            {t.scanDescription}
          </Text>
        </div>
      </div>}
      {qrType === 'feishu' && (
        <div style={{textAlign: 'center',transform: 'scale(0.7)'}}>
          <Title level={2} className="qr-title feishu-qr-title">{t.scanToLogin}</Title>
          <div className="feishu-qr-container" style={{margin: '0 auto'}}>
            <iframe 
              id="feishu-qr-frame" 
              src={`/feishu_qr.html?tenant=${feishuTenant}`}  
              style={{width: '260px', height: '260px', padding: 0,border: 0}}
            ></iframe>
          </div>
          <Text className="qr-description feishu-qr-description">
            {t.fesishuScanDescription}
          </Text>
          <div style={{textAlign: 'center',marginTop: '10px'}}>
            <Button 
              color="primary" 
              variant="link"
              className='feishu-qr-switch-btn' 
              onClick={handleFeishuTenantSwitch}
            >
              {feishuTenant === 'trip' ? t.switchToPartnerTenant : t.switchToPrimaryTenant}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default QRCodeLogin; 